angular.module('stack.common.utility.services.StorageService', [])

/**
 * The StorageService stores utility methods that manage common processes
 * associated with storing data in local storage.
 *
 * @class StorageService
 * @constructor
 * @module stack.common.utility.services.StorageService
 */
.factory('StorageService', [
  '$window',
  function ($window) {
    'use strict';

    var service = {
      /**
       * Method checks the $window object for
       * the localStorage property.
       *
       * @return {boolean} True | False
       */
      hasLocalStorage: function hasLocalStorage() {
        var feature = false;
        try {
          $window.localStorage.setItem('detect', 'detect');
          $window.localStorage.removeItem('detect');
          feature = true;
        } catch (e) {
          feature = false;
        }

        return feature;
      },

      /**
       * Method verifies the existence of local storage
       * before clearing all data stored.
       */
      clearLocalStorage: function clearLocalStorage() {
        var localStorage = service.hasLocalStorage();
        if (localStorage) {
          $window.localStorage.clear();
        }
      }
    };

    return service;
  }
]);
